import {DomainEvent} from './DomainEvent';
import {LiveTicker} from '../resources/LiveTicker';

/**
 * Fired when a live ticker has received enough thumbs up to be awarded as premium live ticker.
 */
export class LiveTickerPremiumAwardReceived extends DomainEvent<LiveTicker> {}
